import { PersonAliasDto, PersonDto } from "@app/api2/api";
import { useFormikContext } from "formik";
import { Button, Form as SForm, FormGroup as SFormGroup } from "@/components/bp/bp-ui";
import SemanticFormikInput from "@common/Forms/SemanticFormikInput";
import SemanticFormikSelect from "@common/Forms/SemanticFormikSelect";
import { keyOfCheckerNested } from "@common/Utils";
import { SectionWithInfo } from "../components/SectionWithInfo";
import { EnrollmentFormSection, EnrollmentFormSectionWithRepeater } from "../components/EnrollmentFormSection";
import { Repeater } from "../components/Repeater";
import { SelectableItem } from "@app/components/React/Hooks/UseSelectableList";
import { useCountryOptions, useStateOptions, useCityOptions, useEthnicityOptions } from "../../Hooks/LookupOptions";

export interface AdditionalTabProps {
}

export const AdditionalTab = ({ }: AdditionalTabProps) => {
    const { values, submitForm } = useFormikContext<PersonDto>();
    const fn = keyOfCheckerNested<typeof values>();
    const pobCountry = useCountryOptions({ defaultValue: values.pobCountryId });
    const pobState = useStateOptions({ defaultValue: values.pobStateId, countryId: values.pobCountryId });
    const pobCity = useCityOptions({ defaultValue: values.pobCityId, countryId: values.pobCountryId, stateId: values.pobStateId });
    const ethnicityOptions = useEthnicityOptions({ defaultValue: values.ethnicityId });

    return (
        <SectionWithInfo title="Additional Information" info="This section is for supplementary information that aids in identification, such as ethnicity, place of birth, known aliases, and parental details.">
            <EnrollmentFormSection sectionKey="personal_background" header="Personal Background" >
                {({ editMode }) => (
                    <>
                        <SFormGroup widths="equal">
                            <SemanticFormikSelect disabled={!editMode} required name={fn("pobCountryId")} clearable label="Place of Birth: Country" {...pobCountry.getDropdownProps()} />
                            <SemanticFormikSelect disabled={!editMode} name={fn("pobStateId")} clearable label="Place of Birth: State" {...pobState.getDropdownProps()} />
                        </SFormGroup>
                        <SFormGroup widths="equal">
                            <SemanticFormikSelect disabled={!editMode} required name={fn("pobCityId")} label="Place of Birth: City" {...pobCity.getDropdownProps()} />
                            <SemanticFormikSelect disabled={!editMode} name={fn("ethnicityId")} label="Ethnicity" {...ethnicityOptions.getDropdownProps()} />
                        </SFormGroup>
                    </>
                )}
            </EnrollmentFormSection>
            <EnrollmentFormSection sectionKey="family_names" header="Family Names" >
                {({ editMode }) => (
                    <SFormGroup widths="equal">
                        <SemanticFormikInput disabled={!editMode} name={fn("fatherLastName")} label="Father's Last Name" maxLength={80} />
                        <SemanticFormikInput disabled={!editMode} name={fn("motherLastName")} label="Mother's Last Name" maxLength={80} />
                    </SFormGroup>
                )}
            </EnrollmentFormSection>
            <EnrollmentFormSectionWithRepeater
                sectionKey="known_aliases"
                header="Known Aliases"
                instanceType={values}
                name="aliases"
                newItemFactory={() => ({ id: null, aliasName: '' } as PersonAliasDto)}
                addButtonLabel="Add Alias"
            >
                {({ editMode, idx }) => (
                    <SemanticFormikInput
                        disabled={!editMode}
                        name={fn(`aliases.${idx}.aliasName`)}
                        label="Alias Name"
                        maxLength={180}
                        required />
                )}
            </EnrollmentFormSectionWithRepeater>

        </SectionWithInfo>
    );
};
